import React from 'react'
import {connect} from 'react-redux'
import {autofill, submit} from 'redux-form'
import {useLocation} from 'react-router-dom'
import {PaginatorWithResult} from 'jbc-front/components/SearchForm'
import {formName, selector} from 'employees/list/utils'

const mapStateToProps = (state, {pathname}) => ({
  pathname,
  count: state.employees.list.count,
  isLoading: state.employees.list.loading,
  page: selector(state, 'page'),
})
const mapDispatchToProps = (dispatch) => ({
  onClick: (page) => {
    dispatch(autofill(formName, 'page', page.toString()))
    dispatch(submit(formName))
  },
})

const ConnectedPaginatorWithResult = connect(mapStateToProps, mapDispatchToProps)(PaginatorWithResult)

const PaginatorWithResultContainer = (props) => {
  const {pathname} = useLocation()
  return <ConnectedPaginatorWithResult {...props} pathname={pathname} />
}

export default PaginatorWithResultContainer
